import React, { useState } from 'react';
import api from '../../services/api';
import toast, { Toaster } from 'react-hot-toast';
import { CheckCircle, QrCode, Copy, Check, X } from 'lucide-react';
import '../../styles/SubComponentsAdmin.css';

const PlanosUpgrade = ({ estabelecimentoId }) => {
    const [planos] = useState([
        {
            id: 'express',
            nome: 'Plano Express',
            preco: '49,90',
            limite: 50,
            recursos: [
                'Até 50 produtos',
                'Cardápio Digital Completo',
                'Mensagens via WhatsApp (pedido recebido, em preparo, rota de entrega, etc.)'
            ]
        },
        {
            id: 'standard',
            nome: 'Plano Standard',
            preco: '79,90',
            limite: 100,
            recursos: [
                'Até 100 produtos',
                'Cardápio Digital Completo',
                'Mensagens via WhatsApp (pedido recebido, em preparo, rota de entrega, etc.)',
                'Suporte via WhatsApp'
            ]
        },
        {
            id: 'premium',
            nome: 'Plano Premium',
            preco: '99,90',
            limite: 300,
            recursos: [
                'Até 300 produtos',
                'Banners Promocionais',
                'Mensagens via WhatsApp (pedido recebido, em preparo, rota de entrega, etc.)',
                'Robô de WhatsApp',
                'Prioridade no Suporte'
            ]
        },
        {
            id: 'enterprise',
            nome: 'Plano Enterprise',
            preco: '149,90',
            limite: 99999,
            recursos: [
                'Produtos Ilimitados',
                'Múltiplos Atendentes',
                'API / Webhook Ativa',
                'Gerente de Conta Dedicado'
            ]
        }
    ]);

    const [loadingPlano, setLoadingPlano] = useState(null);
    const [verificandoPagamento, setVerificandoPagamento] = useState(false);
    const [showPixModal, setShowPixModal] = useState(false);
    const [pixData, setPixData] = useState({ qrCode: '', copiaECola: '', faturaId: null });
    const [copied, setCopied] = useState(false);

    const handleSelecionarPlano = async (plano) => {
        setLoadingPlano(plano.id);
        try {
            // 1. Atualiza o plano e recalcula a fatura vigente no banco
            await api.put(`/cardapio/estabelecimentos/${estabelecimentoId}/plano`, {
                novoPlano: plano.nome
            });

            // 2. Busca as faturas do estabelecimento para pegar o ID da fatura pendente atualizada
            const faturasRes = await api.get(`/cardapio/estabelecimentos/${estabelecimentoId}/faturas`);
            const faturaPendente = faturasRes.data.find(f => f.status === 'pendente') || faturasRes.data[0];

            if (!faturaPendente || !faturaPendente.id) {
                throw new Error("Não foi encontrada fatura pendente para gerar o Pix.");
            }

            // 3. Solicita a geração do Pix real via Efí para essa fatura
            const pixRes = await api.post('/cardapio/assinaturas/gerar-pix', {
                estabelecimento_id: estabelecimentoId,
                fatura_id: faturaPendente.id,
                valor: plano.preco.replace(',', '.')
            });

            setPixData({
                qrCode: pixRes.data.qrcode_base64 || pixRes.data.qrCode || '',
                copiaECola: pixRes.data.copia_e_cola || pixRes.data.pixCopiaECola || '',
                faturaId: faturaPendente.id
            });

            setShowPixModal(true);
            toast.success("QR Code Pix gerado com sucesso!");

        } catch (error) {
            console.error("Erro ao processar upgrade:", error);
            toast.error(error.response?.data?.error || "Erro ao gerar cobrança Pix. Tente novamente.");
        } finally {
            setLoadingPlano(null);
        }
    };

    const verificarPagamento = async () => {
        if (!pixData.faturaId) {
            toast.error("ID da fatura não encontrado.");
            return;
        }

        setVerificandoPagamento(true);
        try {
            const response = await api.get(`/cardapio/assinaturas/verificar/${pixData.faturaId}`);
            
            if (response.data.pago) {
                toast.success("Pagamento confirmado com sucesso! Plano ativado.");
                setShowPixModal(false);
                window.location.reload();
            } else {
                toast.error("O pagamento ainda não foi identificado pela Efí. Tente novamente em alguns segundos.");
            }
        } catch (error) {
            console.error("Erro ao verificar pagamento:", error);
            toast.error("Erro ao verificar status do pagamento.");
        } finally {
            setVerificandoPagamento(false);
        }
    };

    const copiarCopiaECola = () => {
        navigator.clipboard.writeText(pixData.copiaECola);
        setCopied(true);
        toast.success("Código Pix Copia e Cola copiado!");
        setTimeout(() => setCopied(false), 3000);
    };

    return (
        <div className="tab-content animate-fade-in">
            <Toaster position="top-right" />
            <div style={{ marginBottom: '25px', textAlign: 'center' }}>
                <h2 className="content-title" style={{ fontSize: '24px', fontWeight: '800' }}>⚡ Faça o Upgrade do seu Plano</h2>
                <p style={{ color: '#64748b', fontSize: '14px' }}>Escolha o plano ideal para impulsionar suas vendas e expandir seu catálogo de produtos.</p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', maxWidth: '1200px', margin: '0 auto' }}>
                {planos.map((plano) => (
                    <div key={plano.id} style={{ background: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', padding: '25px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                        <div>
                            <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#1e293b', marginBottom: '8px' }}>{plano.nome}</h3>
                            <div style={{ fontSize: '26px', fontWeight: '800', color: '#ea1d2c', marginBottom: '15px' }}>
                                R$ {plano.preco} <span style={{ fontSize: '12px', fontWeight: 'normal', color: '#64748b' }}>/mês</span>
                            </div>
                            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 25px 0', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {plano.recursos.map((rec, idx) => (
                                    <li key={idx} style={{ fontSize: '12px', color: '#475569', display: 'flex', alignItems: 'flex-start', gap: '8px', lineHeight: '1.4' }}>
                                        <CheckCircle size={15} color="#10b981" style={{ flexShrink: 0, marginTop: '2px' }} /> 
                                        <span>{rec}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <button 
                            onClick={() => handleSelecionarPlano(plano)} 
                            disabled={loadingPlano === plano.id}
                            style={{ width: '100%', padding: '12px', background: '#ea1d2c', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', opacity: loadingPlano === plano.id ? 0.7 : 1 }}
                        >
                            {loadingPlano === plano.id ? 'Processando...' : 'Assinar com Pix'}
                        </button>
                    </div>
                ))}
            </div>

            {/* MODAL PIX QR CODE & COPIA E COLA */}
            {showPixModal && (
                <div className="modal-overlay" style={{ zIndex: 3000 }}>
                    <div className="modal" style={{ maxWidth: '450px', width: '90%', textAlign: 'center', padding: '30px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                            <h3 style={{ margin: 0, fontSize: '18px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <QrCode size={22} color="#ea1d2c" /> Pagamento via Pix
                            </h3>
                            <button onClick={() => setShowPixModal(false)} className="btn-close-modal-x"><X size={20} /></button>
                        </div>
                        <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '20px' }}>
                            Escaneie o QR Code abaixo com o aplicativo do seu banco ou utilize o código Copia e Cola. O sistema validará o pagamento automaticamente.
                        </p>

                        {pixData.qrCode ? (
                            <div style={{ background: '#f8fafc', padding: '15px', borderRadius: '12px', display: 'inline-block', marginBottom: '20px', border: '1px solid #e2e8f0' }}>
                                <img src={pixData.qrCode.startsWith('data:') ? pixData.qrCode : `data:image/png;base64,${pixData.qrCode}`} alt="QR Code Pix" style={{ width: '200px', height: '200px', objectFit: 'contain' }} />
                            </div>
                        ) : (
                            <div style={{ padding: '30px', background: '#f8fafc', borderRadius: '12px', marginBottom: '20px', border: '1px dashed #cbd5e1' }}>
                                <QrCode size={40} color="#94a3b8" style={{ marginBottom: '8px' }} />
                                <div style={{ fontSize: '13px', color: '#64748b' }}>Aguardando imagem do QR Code</div>
                            </div>
                        )}

                        <label style={{ fontSize: '12px', fontWeight: '700', color: '#334155', display: 'block', marginBottom: '5px' }}>Pix Copia e Cola:</label>
                        <div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
                            <input 
                                type="text" 
                                readOnly 
                                value={pixData.copiaECola} 
                                style={{ flex: 1, padding: '10px', fontSize: '12px', background: '#f1f5f9', border: '1px solid #cbd5e1', borderRadius: '6px', color: '#0f172a' }} 
                            />
                            <button 
                                onClick={copiarCopiaECola}
                                style={{ background: '#0f172a', color: '#fff', border: 'none', padding: '10px 14px', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', fontWeight: '600' }}
                            >
                                {copied ? <Check size={16} color="#10b981" /> : <Copy size={16} />} 
                                {copied ? 'Copiado' : 'Copiar'}
                            </button>
                        </div>

                        <button 
                            onClick={verificarPagamento}
                            disabled={verificandoPagamento}
                            style={{ width: '100%', padding: '12px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', opacity: verificandoPagamento ? 0.7 : 1 }}
                        >
                            {verificandoPagamento ? 'Verificando pagamento na Efí...' : 'Já realizei o pagamento'}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PlanosUpgrade;